import _regeneratorRuntime from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/regenerator";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/thrstn/Projects/keakort/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator";
import axios from 'axios';
import LocalStorage from 'quasar/src/plugins/LocalStorage.js';;
export function initializeFromStorage(_x) {
  return _initializeFromStorage.apply(this, arguments);
}

function _initializeFromStorage() {
  _initializeFromStorage = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var dispatch, commit, _LocalStorage$getItem, accessToken;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            dispatch = _ref.dispatch, commit = _ref.commit;

            if (!LocalStorage.has('user')) {
              _context.next = 7;
              break;
            }

            _LocalStorage$getItem = LocalStorage.getItem('user'), accessToken = _LocalStorage$getItem.accessToken;
            _context.next = 5;
            return dispatch('setUserAccessToken', accessToken);

          case 5:
            _context.next = 7;
            return commit('updateUser', LocalStorage.getItem('user'));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _initializeFromStorage.apply(this, arguments);
}

export function setUserAccessToken(_ref2, accessToken) {
  var commit = _ref2.commit;

  if (accessToken) {
    commit('updateLoggedIn', true);
    axios.defaults.headers.common['X-Access-Token'] = accessToken;
  }
}
export function authenticateWithApi(_x2, _x3) {
  return _authenticateWithApi.apply(this, arguments);
}

function _authenticateWithApi() {
  _authenticateWithApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3, payload) {
    var dispatch, commit, timeout, response;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            dispatch = _ref3.dispatch, commit = _ref3.commit;
            timeout = axios.defaults.timeout;
            axios.defaults.timeout = 100000;
            _context2.next = 5;
            return axios.post('/authenticate', payload);

          case 5:
            response = _context2.sent;

            if (!(response.status === 200)) {
              _context2.next = 14;
              break;
            }

            if (!response.data.email) {
              _context2.next = 9;
              break;
            }

            return _context2.abrupt("return", response.data.email);

          case 9:
            if (response.data.message) {
              _context2.next = 14;
              break;
            }

            _context2.next = 12;
            return dispatch('setUserAccessToken', response.data.accessToken);

          case 12:
            LocalStorage.set('user', response.data);
            commit('updateUser', response.data);

          case 14:
            axios.defaults.timeout = timeout;
            return _context2.abrupt("return", response);

          case 16:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _authenticateWithApi.apply(this, arguments);
}

export function setLocalStorageForUser(_x4, _x5) {
  return _setLocalStorageForUser.apply(this, arguments);
}

function _setLocalStorageForUser() {
  _setLocalStorageForUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context, payload) {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            LocalStorage.set('user', payload);

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _setLocalStorageForUser.apply(this, arguments);
}

export function updateLocalStorageSettings(_x6, _x7) {
  return _updateLocalStorageSettings.apply(this, arguments);
}

function _updateLocalStorageSettings() {
  _updateLocalStorageSettings = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(context, payload) {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            LocalStorage.set('user', payload);

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _updateLocalStorageSettings.apply(this, arguments);
}

export function updateSettingsForUser(_x8, _x9) {
  return _updateSettingsForUser.apply(this, arguments);
}

function _updateSettingsForUser() {
  _updateSettingsForUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(_ref4, payload) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            commit = _ref4.commit;
            commit('updateUserSettings', payload);

          case 2:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _updateSettingsForUser.apply(this, arguments);
}

export function updateSettingsThroughAPI(_x10, _x11) {
  return _updateSettingsThroughAPI.apply(this, arguments);
}

function _updateSettingsThroughAPI() {
  _updateSettingsThroughAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(context, payload) {
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return axios.post('/settings', payload.settings);

          case 2:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _updateSettingsThroughAPI.apply(this, arguments);
}

export function logoutUser(_x12) {
  return _logoutUser.apply(this, arguments);
}

function _logoutUser() {
  _logoutUser = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(_ref5) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            commit = _ref5.commit;

            if (!LocalStorage.has('user')) {
              _context7.next = 7;
              break;
            }

            _context7.next = 4;
            return axios.post('/logout');

          case 4:
            commit('updateLoggedIn', false);
            _context7.next = 7;
            return LocalStorage.remove('user');

          case 7:
            commit('flush');

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _logoutUser.apply(this, arguments);
}

export function fetchFavoritesFromApi(_x13) {
  return _fetchFavoritesFromApi.apply(this, arguments);
}

function _fetchFavoritesFromApi() {
  _fetchFavoritesFromApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(_ref6) {
    var commit, response;
    return _regeneratorRuntime.wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            commit = _ref6.commit;
            _context8.next = 3;
            return axios.get('/favorites');

          case 3:
            response = _context8.sent;

            if (response.status === 200) {
              commit('updateFavorites', response.data);
            }

          case 5:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _fetchFavoritesFromApi.apply(this, arguments);
}

export function setAsFavorite(_x14, _x15) {
  return _setAsFavorite.apply(this, arguments);
}

function _setAsFavorite() {
  _setAsFavorite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(_ref7, payload) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            commit = _ref7.commit;
            commit('setAsFavorite', payload);

          case 2:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _setAsFavorite.apply(this, arguments);
}

export function setAsFavoriteThroughApi(_x16, _x17) {
  return _setAsFavoriteThroughApi.apply(this, arguments);
}

function _setAsFavoriteThroughApi() {
  _setAsFavoriteThroughApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(context, payload) {
    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
      while (1) {
        switch (_context10.prev = _context10.next) {
          case 0:
            _context10.next = 2;
            return axios.post('/favorites', {
              affiliateId: payload.affiliateId
            });

          case 2:
          case "end":
            return _context10.stop();
        }
      }
    }, _callee10);
  }));
  return _setAsFavoriteThroughApi.apply(this, arguments);
}

export function removeAsFavorite(_x18, _x19) {
  return _removeAsFavorite.apply(this, arguments);
}

function _removeAsFavorite() {
  _removeAsFavorite = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(_ref8, id) {
    var commit;
    return _regeneratorRuntime.wrap(function _callee11$(_context11) {
      while (1) {
        switch (_context11.prev = _context11.next) {
          case 0:
            commit = _ref8.commit;
            commit('removeAsFavorite', id);

          case 2:
          case "end":
            return _context11.stop();
        }
      }
    }, _callee11);
  }));
  return _removeAsFavorite.apply(this, arguments);
}

export function removeAsFavoriteThroughApi(_x20, _x21) {
  return _removeAsFavoriteThroughApi.apply(this, arguments);
}

function _removeAsFavoriteThroughApi() {
  _removeAsFavoriteThroughApi = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(context, payload) {
    return _regeneratorRuntime.wrap(function _callee12$(_context12) {
      while (1) {
        switch (_context12.prev = _context12.next) {
          case 0:
            _context12.next = 2;
            return axios.delete("/favorites/".concat(payload.affiliateId));

          case 2:
          case "end":
            return _context12.stop();
        }
      }
    }, _callee12);
  }));
  return _removeAsFavoriteThroughApi.apply(this, arguments);
}

export function updatePushToken(_x22, _x23) {
  return _updatePushToken.apply(this, arguments);
}

function _updatePushToken() {
  _updatePushToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(_ref9, payload) {
    var commit, state;
    return _regeneratorRuntime.wrap(function _callee13$(_context13) {
      while (1) {
        switch (_context13.prev = _context13.next) {
          case 0:
            commit = _ref9.commit, state = _ref9.state;

            if (!payload) {
              _context13.next = 6;
              break;
            }

            commit('updatePushToken', payload);

            if (!(state.user && state.user.accessToken)) {
              _context13.next = 6;
              break;
            }

            _context13.next = 6;
            return axios.post('/pushToken', {
              pushToken: payload
            });

          case 6:
          case "end":
            return _context13.stop();
        }
      }
    }, _callee13);
  }));
  return _updatePushToken.apply(this, arguments);
}